<div
  class="player"
  class="dropbox"
  [ngClass]="{ 'on-drag': onDrag }"
  (dragover)="$event.preventDefault()"
  (dragenter)="onDragEnter()"
  (dragleave)="onDragLeave()"
  (drop)="onDrop($event)"
>
  <ng-container *ngIf="liveSource; then player; else empty"></ng-container>
  <ng-template #player>
    <div class="player" #fullscreenContainer [class.fullscreen]="isFullScreen">
      <div class="top-bar">
        <a
          class="expand-screen"
          [href]="'/content-control/studio/' + liveSource.id + '/edit'"
          target="_blank"
        >
          <svg
            width="14"
            height="13"
            viewBox="0 0 14 13"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M11.494 1.99365H4.34249V6.99828H2.56885V10.9417H6.52717V9.14516H11.494V1.99365H11.494ZM6.0016 10.4161H3.09444V7.52386H4.34248V9.14516H6.00158V10.4161H6.0016ZM6.0016 8.61957H4.86808V7.52386H6.0016V8.61957ZM10.9684 8.61957H6.52717V6.99826H4.86807V2.51924H10.9684V8.61957H10.9684Z"
              fill="white"
            />
            <path
              d="M7.45074 6.44786L9.85489 4.04371V4.78476H10.3805V3.14648H8.74223V3.67208H9.48325L7.0791 6.07622L7.45074 6.44786Z"
              fill="white"
            />
          </svg>
        </a>
        <div class="title">
          <span>{{ liveSource.name }}</span>
        </div>
        <div class="assets-container">
          <div class="frame">
            <div class="icon-mute" (click)="toggleMute()">
              <svg
                width="15"
                height="15"
                viewBox="0 0 15 15"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <rect
                  x="0.130371"
                  y="0.31543"
                  width="14.2802"
                  height="14.2802"
                  rx="1.78503"
                  fill="white"
                  fill-opacity="0.1"
                />
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M3.88787 5.15256C3.21584 5.86389 2.80811 6.78818 2.80811 7.79718V9.70977C2.80811 10.1053 3.15999 10.427 3.59254 10.427H3.85402V8.03625H3.59254C3.50043 8.03625 3.41326 8.0535 3.33106 8.08029V7.79718C3.33106 6.92769 3.67457 6.12952 4.24335 5.50805L3.88787 5.15256ZM9.11684 10.3815V10.6663C9.11684 10.7983 9.23391 10.9053 9.37832 10.9053H9.6398C9.64009 10.9053 9.64037 10.9053 9.64066 10.9053L9.11684 10.3815ZM10.1628 9.37059L9.11684 8.32467V7.79738C9.11684 7.66534 9.23391 7.5583 9.37832 7.5583H9.6398C9.92863 7.5583 10.1628 7.77237 10.1628 8.03645V9.37059ZM10.6873 9.89517V8.03625H10.9488C11.0409 8.03625 11.1281 8.0535 11.2103 8.08029V7.79718C11.2103 5.81968 9.4335 4.21106 7.27068 4.21106C6.6051 4.21106 5.97607 4.3634 5.42413 4.63196L5.06126 4.26909C5.71399 3.92804 6.46881 3.73291 7.27068 3.73291C9.72179 3.73291 11.7333 5.55609 11.7333 7.79718V9.70977C11.7333 10.0306 11.5017 10.3029 11.1833 10.3943C11.1711 10.38 11.1582 10.3661 11.1447 10.3526L10.6873 9.89517ZM4.89978 7.5583H5.16126C5.30567 7.5583 5.42274 7.66534 5.42274 7.79738V10.6663C5.42274 10.7983 5.30567 10.9053 5.16126 10.9053H4.89978C4.61095 10.9053 4.37682 10.6913 4.37682 10.4272V8.03645C4.37682 7.77237 4.61095 7.5583 4.89978 7.5583Z"
                  fill="white"
                />
                <rect
                  x="3.2085"
                  y="4.02686"
                  width="0.872652"
                  height="10.5697"
                  rx="0.436326"
                  transform="rotate(-45 3.2085 4.02686)"
                  fill="white"
                />
              </svg>
            </div>
            <select
              [ngModel]="currentAudioTrack"
              (ngModelChange)="changeAudioTrack($event)"
              class="language-selector"
            >
              <option [value]="-1">Source</option>
              <option *ngFor="let track of audioTracks" [value]="track.id">
                {{ track.name }} ({{ track.language }})
              </option>
            </select>
          </div>
        </div>
        <div class="assets-container">
          <div class="frame">
            <div class="icon-subs">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="13"
                height="13"
                viewBox="0 0 13 13"
                fill="none"
              >
                <path
                  d="M9.80775 9.89836H2.79513C2.54152 9.89836 2.29829 9.79761 2.11895 9.61828C1.93962 9.43894 1.83887 9.19571 1.83887 8.9421V3.84201C1.83887 3.58839 1.93962 3.34516 2.11895 3.16583C2.29829 2.98649 2.54152 2.88574 2.79513 2.88574H9.80775C10.0614 2.88574 10.3046 2.98649 10.4839 3.16583C10.6633 3.34516 10.764 3.58839 10.764 3.84201V8.9421C10.764 9.19571 10.6633 9.43894 10.4839 9.61828C10.3046 9.79761 10.0614 9.89836 9.80775 9.89836ZM2.79513 3.52325C2.71059 3.52325 2.62952 3.55684 2.56974 3.61661C2.50996 3.67639 2.47638 3.75747 2.47638 3.84201V8.9421C2.47638 9.02664 2.50996 9.10771 2.56974 9.16749C2.62952 9.22727 2.71059 9.26085 2.79513 9.26085H9.80775C9.89229 9.26085 9.97337 9.22727 10.0331 9.16749C10.0929 9.10771 10.1265 9.02664 10.1265 8.9421V3.84201C10.1265 3.75747 10.0929 3.67639 10.0331 3.61661C9.97337 3.55684 9.89229 3.52325 9.80775 3.52325H2.79513ZM5.02642 6.39205C5.02642 6.30751 4.99284 6.22644 4.93306 6.16666C4.87328 6.10688 4.79221 6.0733 4.70767 6.0733H3.7514C3.66686 6.0733 3.58578 6.10688 3.52601 6.16666C3.46623 6.22644 3.43264 6.30751 3.43264 6.39205C3.43264 6.47659 3.46623 6.55767 3.52601 6.61745C3.58578 6.67723 3.66686 6.71081 3.7514 6.71081H4.70767C4.79221 6.71081 4.87328 6.67723 4.93306 6.61745C4.99284 6.55767 5.02642 6.47659 5.02642 6.39205ZM9.17024 6.39205C9.17024 6.30751 9.13666 6.22644 9.07688 6.16666C9.0171 6.10688 8.93603 6.0733 8.85149 6.0733H6.30144C6.2169 6.0733 6.13583 6.10688 6.07605 6.16666C6.01627 6.22644 5.98269 6.30751 5.98269 6.39205C5.98269 6.47659 6.01627 6.55767 6.07605 6.61745C6.13583 6.67723 6.2169 6.71081 6.30144 6.71081H8.85149C8.93603 6.71081 9.0171 6.67723 9.07688 6.61745C9.13666 6.55767 9.17024 6.47659 9.17024 6.39205ZM9.17024 7.98583C9.17024 7.90129 9.13666 7.82021 9.07688 7.76044C9.0171 7.70066 8.93603 7.66707 8.85149 7.66707H7.89522C7.81068 7.66707 7.7296 7.70066 7.66983 7.76044C7.61005 7.82021 7.57647 7.90129 7.57647 7.98583C7.57647 8.07037 7.61005 8.15145 7.66983 8.21122C7.7296 8.271 7.81068 8.30459 7.89522 8.30459H8.85149C8.93603 8.30459 9.0171 8.271 9.07688 8.21122C9.13666 8.15145 9.17024 8.07037 9.17024 7.98583ZM6.6202 7.98583C6.6202 7.90129 6.58662 7.82021 6.52684 7.76044C6.46706 7.70066 6.38598 7.66707 6.30144 7.66707H3.7514C3.66686 7.66707 3.58578 7.70066 3.52601 7.76044C3.46623 7.82021 3.43264 7.90129 3.43264 7.98583C3.43264 8.07037 3.46623 8.15145 3.52601 8.21122C3.58578 8.271 3.66686 8.30459 3.7514 8.30459H6.30144C6.38598 8.30459 6.46706 8.271 6.52684 8.21122C6.58662 8.15145 6.6202 8.07037 6.6202 7.98583Z"
                  fill="white"
                />
              </svg>
            </div>
            <select
              [ngModel]="currentSubtitleTrack"
              (ngModelChange)="changeSubtitleTrack($event)"
              class="subtitle-selector"
            >
              <option [value]="-1">Off</option>
              <option *ngFor="let track of subtitleTracks" [value]="track.id">
                {{ track.name }} ({{ track.language }})
              </option>
            </select>
          </div>
        </div>
        <div class="close" (click)="closeVideo($event)">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="14"
            height="13"
            viewBox="0 0 14 13"
            fill="none"
          >
            <path
              d="M10.4209 3.91266C10.6236 3.70995 10.6236 3.38128 10.4209 3.17857C10.2181 2.97586 9.88947 2.97586 9.68676 3.17857L7.14346 5.72187L4.60016 3.17857C4.39745 2.97586 4.06878 2.97586 3.86607 3.17857C3.66336 3.38128 3.66336 3.70995 3.86607 3.91266L6.40937 6.45596L3.86607 8.99926C3.66336 9.20197 3.66336 9.53064 3.86607 9.73335C4.06878 9.93607 4.39745 9.93607 4.60016 9.73335L7.14346 7.19005L9.68676 9.73335C9.88947 9.93606 10.2181 9.93607 10.4209 9.73335C10.6236 9.53064 10.6236 9.20197 10.4209 8.99926L7.87755 6.45596L10.4209 3.91266Z"
              fill="white"
            />
          </svg>
        </div>
      </div>
      <div class="video">
        <div class="video-wrapper">
          <video #videoPlayer style="width: 100%; height: 100%" muted>
            <track kind="subtitles" label="Subtitles" default />
          </video>
          <canvas #videoCanvas></canvas>
        </div>
      </div>

      <div class="controls">
        <div
          class="progress-container"
          (mousemove)="onProgressBarMouseMove($event)"
          (mouseleave)="onProgressBarMouseLeave()"
          (mousedown)="onProgressBarMouseDown($event)"
        >
          <svg
            #progressSvg
            class="progress-svg"
            viewBox="0 0 180 6"
            preserveAspectRatio="none"
          >
            <mask
              id="progress-mask"
              maskUnits="userSpaceOnUse"
              x="0"
              y="0"
              width="180"
              height="6"
            >
              <rect x="0" y="0" width="180" height="6" fill="white" />
            </mask>
            <g mask="url(#progress-mask)">
              <rect
                x="0"
                y="0"
                width="180"
                height="6"
                fill="white"
                fill-opacity="0.1"
              />

              <ng-container *ngFor="let tick of progressTicks">
                <line
                  [attr.x1]="tick.x"
                  [attr.x2]="tick.x"
                  [attr.y1]="tick.y1"
                  [attr.y2]="tick.y2"
                  stroke="white"
                  stroke-width="0.202346"
                  stroke-opacity="0.85"
                />
              </ng-container>

              <g
                [attr.transform]="'translate(' + getPlayheadPosition() + ', 0)'"
              >
                <rect
                  x="-0.1"
                  y="0.32"
                  width="0.202346"
                  height="5.09179"
                  fill="#A2E0FD"
                />
                <path
                  d="M-0.452 0.319336H0.452L0.451 1.16447L0 1.59228L-0.453 1.16447L-0.452 0.319336Z"
                  fill="#A2E0FD"
                />
              </g>
            </g>
          </svg>

          <!-- Tooltip -->
          <div
            class="time-tooltip"
            *ngIf="tooltipPosition !== null"
            [style.left.px]="tooltipPosition"
          >
            {{ MillisecondsToFormattedDuration(tooltipTime * 1000) }}
          </div>
        </div>
        <div class="full-screen" (click)="toggleFullscreen()">
          <svg
            width="7"
            height="7"
            viewBox="0 0 7 7"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g clip-path="url(#clip0_4650_48202)">
              <path
                d="M4.02675 2.74881L5.25574 1.51982V2.02482C5.25574 2.13268 5.34318 2.22011 5.45104 2.22011C5.5589 2.22011 5.64634 2.13268 5.64634 2.02482V1.04834C5.64634 1.04191 5.64601 1.03547 5.64537 1.02905C5.64509 1.02616 5.64455 1.02336 5.64414 1.02051C5.64364 1.01706 5.64324 1.0136 5.64256 1.01017C5.64191 1.00689 5.64102 1.00371 5.6402 1.0005C5.63946 0.997542 5.63881 0.994567 5.63792 0.991637C5.63697 0.988479 5.63578 0.985431 5.63467 0.982345C5.63362 0.979425 5.63266 0.976477 5.63147 0.973594C5.63028 0.97071 5.62887 0.967954 5.62755 0.965144C5.62615 0.962178 5.62483 0.959184 5.62327 0.956273C5.62183 0.953582 5.62019 0.951018 5.61862 0.9484C5.61692 0.945553 5.61531 0.942669 5.61345 0.939886C5.61152 0.936994 5.60936 0.934275 5.60728 0.931492C5.60554 0.929175 5.60393 0.926795 5.60208 0.924534C5.59803 0.9196 5.59376 0.914848 5.58925 0.910335C5.58921 0.910299 5.58918 0.910262 5.58915 0.910225C5.58911 0.910189 5.58907 0.91017 5.58904 0.910134C5.58452 0.905621 5.57978 0.901345 5.57484 0.89729C5.57258 0.895432 5.5702 0.89382 5.56787 0.892081C5.5651 0.890003 5.56238 0.887852 5.55948 0.88592C5.5567 0.884062 5.55382 0.88245 5.55096 0.880748C5.54834 0.879182 5.54579 0.877543 5.5431 0.876097C5.54019 0.874541 5.5372 0.873222 5.53423 0.871822C5.53142 0.870494 5.52865 0.869094 5.52578 0.867894C5.52289 0.866704 5.51995 0.865734 5.51702 0.86469C5.51393 0.863583 5.51089 0.862402 5.50774 0.86145C5.50481 0.860562 5.50183 0.859912 5.49887 0.85917C5.49566 0.858355 5.49248 0.857458 5.48921 0.856808C5.48578 0.856131 5.48232 0.855719 5.47887 0.855224C5.47602 0.854822 5.47322 0.854272 5.47033 0.853989C5.46391 0.853366 5.45748 0.853027 5.45105 0.853027H4.47455C4.36669 0.853027 4.27926 0.940463 4.27926 1.04832C4.27926 1.15618 4.36669 1.24362 4.47455 1.24362H4.97955L3.75056 2.47262C3.67429 2.54888 3.67429 2.67254 3.75056 2.74881C3.82683 2.82508 3.95049 2.82508 4.02675 2.74881Z"
                fill="white"
              />
              <path
                d="M2.57906 3.64411L1.35007 4.8731V4.36811C1.35007 4.26025 1.26264 4.17281 1.15478 4.17281C1.04691 4.17281 0.959473 4.26025 0.959473 4.36811V5.3446C0.959473 5.35104 0.959811 5.35747 0.960443 5.36387C0.960727 5.36676 0.961267 5.36956 0.961679 5.37241C0.962173 5.37587 0.962576 5.37934 0.963263 5.38276C0.963913 5.38604 0.96481 5.3892 0.965625 5.39242C0.966366 5.39538 0.967016 5.39836 0.967904 5.40129C0.968856 5.40444 0.970037 5.40749 0.971145 5.41056C0.972198 5.41349 0.973159 5.41644 0.974349 5.41932C0.975539 5.42221 0.976949 5.42496 0.978276 5.42777C0.979677 5.43074 0.980995 5.43373 0.982551 5.43664C0.983998 5.43934 0.985637 5.44189 0.987202 5.44451C0.988905 5.44735 0.990516 5.45025 0.992374 5.45303C0.994306 5.45592 0.996457 5.45863 0.998535 5.46142C1.00027 5.46374 1.00189 5.46612 1.00374 5.46838C1.0078 5.47333 1.01208 5.47808 1.01659 5.48259C1.01662 5.48263 1.01664 5.48266 1.01668 5.48269C1.01672 5.48273 1.01675 5.48276 1.01679 5.48279C1.0213 5.4873 1.02605 5.49157 1.03099 5.49563C1.03325 5.49749 1.03563 5.4991 1.03795 5.50083C1.04073 5.5029 1.04345 5.50507 1.04634 5.507C1.04911 5.50886 1.052 5.51047 1.05485 5.51217C1.05747 5.51373 1.06003 5.51537 1.06273 5.51682C1.06564 5.51838 1.06863 5.51969 1.0716 5.5211C1.07441 5.52242 1.07717 5.52382 1.08005 5.52501C1.08293 5.5262 1.08587 5.52716 1.0888 5.52822C1.09189 5.52932 1.09493 5.53051 1.09809 5.53147C1.10102 5.53236 1.104 5.53301 1.10695 5.53375C1.11017 5.53456 1.11334 5.53546 1.11662 5.53611C1.12005 5.53679 1.12351 5.53719 1.12697 5.53768C1.12981 5.53809 1.13262 5.53864 1.13551 5.53892C1.14192 5.53955 1.14834 5.53989 1.15477 5.53989H2.13126C2.23912 5.53989 2.32656 5.45245 2.32656 5.34459C2.32656 5.23673 2.23912 5.1493 2.13126 5.1493H1.62627L2.85526 3.92031C2.93152 3.84404 2.93152 3.72038 2.85526 3.64411C2.77899 3.56785 2.65533 3.56785 2.57906 3.64411Z"
                fill="white"
              />
              <path
                d="M5.60731 5.4614C5.60938 5.45863 5.61153 5.45592 5.61345 5.45304C5.61532 5.45026 5.61693 5.44736 5.61863 5.44451C5.62019 5.4419 5.62183 5.43934 5.62326 5.43666C5.62482 5.43375 5.62615 5.43075 5.62755 5.42777C5.62888 5.42497 5.63027 5.42222 5.63147 5.41934C5.63266 5.41646 5.63363 5.41351 5.63467 5.41058C5.63578 5.4075 5.63696 5.40446 5.63791 5.40131C5.6388 5.39838 5.63945 5.39539 5.64019 5.39244C5.64101 5.38922 5.6419 5.38605 5.64255 5.38278C5.64323 5.37934 5.64363 5.37588 5.64414 5.37243C5.64454 5.36959 5.64509 5.36678 5.64537 5.36389C5.64601 5.35747 5.64634 5.35104 5.64634 5.3446V4.36811C5.64634 4.26025 5.55891 4.17281 5.45105 4.17281C5.34319 4.17281 5.25575 4.26025 5.25575 4.36811V4.8731L4.02675 3.64411C3.95049 3.56785 3.82683 3.56785 3.75056 3.64411C3.67429 3.72038 3.67429 3.84404 3.75056 3.92031L4.97955 5.1493H4.47455C4.36669 5.1493 4.27926 5.23673 4.27926 5.34459C4.27926 5.45245 4.36669 5.5399 4.47455 5.5399H5.45105C5.45748 5.5399 5.46391 5.53956 5.47032 5.53893C5.4732 5.53864 5.476 5.5381 5.47886 5.53769C5.48231 5.5372 5.48578 5.53679 5.4892 5.53611C5.49248 5.53546 5.49565 5.53456 5.49886 5.53375C5.50183 5.533 5.5048 5.53235 5.50773 5.53147C5.51088 5.53051 5.51393 5.52933 5.51701 5.52823C5.51994 5.52717 5.52288 5.52621 5.52577 5.52502C5.52864 5.52383 5.5314 5.52243 5.5342 5.5211C5.53717 5.5197 5.54018 5.51838 5.54309 5.51682C5.54577 5.51538 5.54833 5.51374 5.55093 5.51219C5.55379 5.51048 5.55668 5.50886 5.55947 5.50701C5.56235 5.50507 5.56506 5.50293 5.56782 5.50086C5.57016 5.49911 5.57255 5.49749 5.57482 5.49564C5.57972 5.49162 5.58443 5.48737 5.58892 5.48289C5.58899 5.48283 5.58906 5.48276 5.58913 5.4827C5.58919 5.48264 5.58926 5.48255 5.58932 5.48249C5.59379 5.478 5.59803 5.4733 5.60206 5.46839C5.60394 5.46612 5.60556 5.46373 5.60731 5.4614Z"
                fill="white"
              />
              <path
                d="M1.62627 1.24363H2.13126C2.23912 1.24363 2.32656 1.15619 2.32656 1.04833C2.32656 0.940463 2.23912 0.853027 2.13126 0.853027H1.15477C1.14834 0.853027 1.1419 0.853366 1.1355 0.853998C1.1326 0.854282 1.1298 0.854822 1.12696 0.855234C1.12351 0.855728 1.12004 0.856131 1.11661 0.856808C1.11333 0.857458 1.11016 0.858355 1.10694 0.85917C1.10399 0.859912 1.10101 0.860562 1.09808 0.86145C1.09492 0.862402 1.09188 0.863592 1.08879 0.864699C1.08587 0.865752 1.08292 0.866713 1.08004 0.867904C1.07716 0.869103 1.07438 0.870504 1.07157 0.87184C1.06861 0.873232 1.06562 0.87455 1.06272 0.876106C1.06002 0.877553 1.05745 0.8792 1.05483 0.880766C1.05199 0.882459 1.04911 0.884062 1.04633 0.88592C1.04343 0.887861 1.0407 0.890021 1.03791 0.892108C1.0356 0.893839 1.03323 0.895441 1.03099 0.89729C1.02104 0.905456 1.0119 0.914592 1.00374 0.924543C1.00189 0.926786 1.00028 0.929157 0.998554 0.931473C0.996466 0.934265 0.994306 0.936994 0.992365 0.939896C0.990507 0.942669 0.988905 0.945544 0.987202 0.948391C0.985637 0.951009 0.983989 0.953582 0.982542 0.956282C0.980986 0.959184 0.979677 0.962169 0.978276 0.965135C0.976949 0.967945 0.975539 0.970719 0.97434 0.973603C0.97315 0.976487 0.972188 0.979425 0.971136 0.982355C0.970028 0.98544 0.968847 0.988488 0.967886 0.991647C0.966998 0.994576 0.966348 0.997551 0.965606 1.00051C0.964791 1.00372 0.963894 1.0069 0.963244 1.01018C0.962567 1.01361 0.962164 1.01707 0.96167 1.02052C0.961267 1.02337 0.960718 1.02618 0.960434 1.02906C0.959811 1.03546 0.959473 1.04189 0.959473 1.04832V2.02482C0.959473 2.13268 1.04691 2.22011 1.15477 2.22011C1.26263 2.22011 1.35006 2.13268 1.35006 2.02482V1.51982L2.57905 2.74881C2.65532 2.82508 2.77898 2.82508 2.85525 2.74881C2.93151 2.67254 2.93151 2.54888 2.85525 2.47262L1.62627 1.24363Z"
                fill="white"
              />
            </g>
            <defs>
              <clipPath id="clip0_4650_48202">
                <rect
                  width="6.24761"
                  height="6.24761"
                  fill="white"
                  transform="translate(0.179199 0.0727539)"
                />
              </clipPath>
            </defs>
          </svg>
        </div>
        <div
          class="live"
          [class.is-live]="isLive"
          (click)="!isLive && moveToLiveEdge()"
        >
          <span>LIVE</span>
        </div>
        <div class="play" (click)="togglePlayPause()">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="7"
            height="7"
            viewBox="0 0 7 7"
            fill="none"
          >
            <path
              d="M2.18408 5.06527C2.18408 5.24371 2.39049 5.34291 2.52983 5.23144L4.78779 3.42508C4.89428 3.33989 4.89428 3.17792 4.78779 3.09273L2.52983 1.28637C2.39049 1.17489 2.18408 1.2741 2.18408 1.45254V5.06527Z"
              fill="white"
            />
          </svg>
        </div>
      </div>
    </div>
  </ng-template>
  <ng-template #empty>
    <div class="empty-screen">
      <div class="add">
        <svg
          width="20"
          height="21"
          viewBox="0 0 20 21"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M16.9818 10.6955C16.9818 11.2321 16.5468 11.667 16.0102 11.667H11.1524V16.5249C11.1524 17.0614 10.7174 17.4964 10.1808 17.4964V17.4964C9.64425 17.4964 9.20927 17.0614 9.20927 16.5249V11.667H4.35145C3.81487 11.667 3.37988 11.2321 3.37988 10.6955V10.6955C3.37988 10.1589 3.81487 9.72391 4.35145 9.72391H9.20927V4.8661C9.20927 4.32952 9.64425 3.89453 10.1808 3.89453V3.89453C10.7174 3.89453 11.1524 4.32951 11.1524 4.86609V9.72391H16.0102C16.5468 9.72391 16.9818 10.1589 16.9818 10.6955V10.6955Z"
            fill=""
          />
        </svg>
      </div>
    </div>
  </ng-template>
</div>
